import { ThemedTextProps } from 'libs/contentful/props';
import { documentToReactComponents } from '@contentful/rich-text-react-renderer';
import { BLOCKS, Node } from '@contentful/rich-text-types';

const ThemedText = ({ themedText }: ThemedTextProps) => {
  return documentToReactComponents(themedText.json, {
    renderNode: {
      [BLOCKS.PARAGRAPH]: (_node: Node, children: React.ReactNode) => (
        <span className={'text-(--themed-text-color)'}>{children}</span>
      ),
    },
  });
};

export default ThemedText;
